import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { ShipmentStatusMappingAdapter } from '../adapters/shipmentStatusMappingAdapter';

export const useShipmentStatusMappingStats = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShipmentStatusMappingAdapter(httpClient);

  const { data: total = 0, isLoading: isLoadingTotal } = useQuery({
    queryKey: ['shipment-status-mappings-stats-total'],
    queryFn: () => adapter.fetchShipmentStatusMappingsPaginated({ page: 1, per_page: 1 }),
    select: (response) => response.total,
    staleTime: 2 * 60 * 1000,
  });

  const { data: unmapped = 0, isLoading: isLoadingUnmapped } = useQuery({
    queryKey: ['shipment-status-mappings-stats-unmapped'],
    queryFn: () =>
      adapter.fetchShipmentStatusMappingsPaginated({
        shipment_status_id: null,
        page: 1,
        per_page: 1,
      }),
    select: (response) => response.total,
    staleTime: 2 * 60 * 1000,
  });

  return {
    total,
    unmapped,
    mapped: Math.max(total - unmapped, 0),
    isLoading: isLoadingTotal || isLoadingUnmapped,
  };
};
